import { Checkbox } from '@rsos/base-components';
import { isPublicSonarLayer } from '@rsos/components/capstone/common/Map/selectMarkerIcon';
import { RegularCheckboxWrapper } from './LayerCheckbox.styles';
import {
  Layer,
  GISService,
  isSpatialLayer,
  isGISLayer,
} from './LayerCheckbox.types';

interface NormalizedLayerCheckboxProps {
  layer: Layer;
  layerID: number | string;
  isDisabled: boolean;
  isGISSupplementalLayer: boolean;
  activeGISServices: GISService[];
  handleCheckboxOnChange: () => void;
  handleGISCheckboxOnChange: (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => void;
}

const NormalizedLayerCheckbox: React.FC<NormalizedLayerCheckboxProps> = ({
  layer,
  layerID,
  isDisabled,
  isGISSupplementalLayer,
  activeGISServices,
  handleCheckboxOnChange,
  handleGISCheckboxOnChange,
}) => {
  // For GIS layers without sublayers
  if (isGISSupplementalLayer && isGISLayer(layer)) {
    return (
      <RegularCheckboxWrapper>
        <Checkbox
          key={String(layerID)}
          label={layer.display_name}
          isChecked={
            !!activeGISServices.filter(
              (service: GISService) => service.id === layerID,
            ).length
          }
          disabled={isDisabled}
          onChange={handleGISCheckboxOnChange}
        />
      </RegularCheckboxWrapper>
    );
  }

  // For spatial layers
  return (
    <RegularCheckboxWrapper>
      <Checkbox
        key={String(layerID)}
        label={
          isSpatialLayer(layer) ? layer.title || layer.category?.name || '' : ''
        }
        isChecked={isSpatialLayer(layer) ? layer.isChecked : false}
        description={
          isSpatialLayer(layer)
            ? isPublicSonarLayer(layer.key)
              ? layer.source
              : layer.name
            : undefined
        }
        onChange={handleCheckboxOnChange}
      />
    </RegularCheckboxWrapper>
  );
};

export default NormalizedLayerCheckbox;
